import React, { Component } from 'react';
import NavBar from '../../components/navigation/NavBar';
import RateView from '../../components/rateview/RateView';
import { getCurrentResource } from '../../util/tools';
import { FORM_EVENT_TABLE } from '../../util/consts/forms';

class EventListPage extends Component {
	constructor(props) {
		super(props);

		this.resource = getCurrentResource().pages.tableform.EventList;
		var paramCacheId = props.match.params.param;

		this.rvContext = {
			form: FORM_EVENT_TABLE,
			data: []
		}
		this.rvOptions = {
			form: FORM_EVENT_TABLE,
			formTitle: this.resource.formTitle,
			paramCacheId: paramCacheId,
			transition: null,
			hideButtonSendEmail: true,
		};
	}
	componentDidMount() {
		document.title = 'BOM. ' + this.resource.formTitle;
	}
	
	render() {
		return (
			<React.Fragment>
				<NavBar app={this.props.app} />
				<RateView rvContext={this.rvContext} rvOptions={this.rvOptions} app={this.props.app}  />
			</React.Fragment>
		)
	}
	
}

export default EventListPage;
